<template>
  <div class="widget-configuration-sidepanel px-4">
    <b-row class="d-flex align-items-center mb-2">
      <b-col class="d-flex align-items-center">
        <span class="title">{{ $t('dashboard.widget.widgetSettings') }}</span>
      </b-col>
      <b-col
        cols="auto"
        class="d-flex justify-content-end"
      >
        <div>
          <b-button
            v-shortkey="['shift', 'esc']"
            class="btn__icon btn__icon--primary p-0"
            @shortkey="closeWidgetConfigurationSidepanel"
            @click="closeWidgetConfigurationSidepanel"
          >
            <i
              class="far fa-times"
              aria-hidden="true"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <!-- TODO: A petición de Javier se comenta, se desarrollará más adelante -->
    <!--<b-row>
            <b-col>
                <b-form-group>
                    <div class="form-label">
                        <label>{{ $t('dashboard.widget.pretitle') }}</label>
                    </div>
                    <vt-input disabled class="form-control-sm" value="Estudios demorados" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group>
                    <div class="form-label">
                        <label>{{ $t('dashboard.widget.title') }}</label>
                    </div>
                    <vt-input disabled class="form-control-sm" value="Demora global" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group>
                    <div class="form-label">
                        <label>{{ $t('dashboard.widget.cardColor') }}</label>
                    </div>
                    <div class="color-row">
                        <b-button style="background: rgb(240,59,94) !important;" class="color-btn modal-color-btn ml-1"></b-button>
                        <b-button style="background: rgb(76,240,159) !important;" class="color-btn modal-color-btn ml-1"></b-button>
                        <b-button style="background: rgb(138,142,240) !important;" class="color-btn modal-color-btn ml-1"></b-button>
                        <b-button style="background: rgb(79,208,240) !important;" class="color-btn modal-color-btn selected ml-1"></b-button>
                        <b-button style="background: rgb(240,224,86) !important;" class="color-btn modal-color-btn ml-1"></b-button>
                        <b-button style="background: rgb(240,166,51) !important;" class="color-btn modal-color-btn ml-1"></b-button>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>-->
    <!--<b-row>
            <b-col>
                <hr/>
            </b-col>
        </b-row>-->
    <!-- Sidepanel title area -->
    <b-row class="mb-2">
      <b-col>
        <span class="subtitle">
          {{ $t(item.label) }}
        </span>
      </b-col>
    </b-row>
    <!-- Chart-widget view -->
    <div v-if="item.type === 'chart-widget'">
      <b-row class="multiselection">
        <b-col>
          <b-form-group>
            <div class="form-label">
              <label>{{ $t('dashboard.widget.laboratory') }}</label>
            </div>
            <vt-combo-select
              v-model="laboratoriesSelected"
              track-by="labId"
              label="labName"
              :multiple="true"
              :close-on-select="false"
              :options="laboratories"
              @remove="saveConfiguration"
              @input="saveConfiguration"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="multiselection">
        <b-col>
          <b-form-group>
            <div class="form-label">
              <label>{{ $t('dashboard.widget.priority') }}</label>
            </div>
            <vt-combo-select
              v-model="prioritiesSelected"
              track-by="id"
              label="name"
              :multiple="true"
              :close-on-select="false"
              :options="priorities"
              @remove="saveConfiguration"
              @input="saveConfiguration"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="multiselection">
        <b-col>
          <b-form-group>
            <div class="form-label">
              <label>{{ $t('dashboard.widget.caseType') }}</label>
            </div>
            <vt-combo-select
              v-model="caseTypesSelected"
              track-by="id"
              label="description"
              :multiple="true"
              :close-on-select="false"
              :options="caseTypes"
              @remove="saveConfiguration"
              @input="saveConfiguration"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <div class="form-label">
              <label>{{ $t('dashboard.widget.caseSituation') }}</label>
            </div>
            <vt-combo-select
              v-model="caseSituationsSelected"
              class="mt-1"
              track-by="key"
              :placeholder="$t('dashboard.widget.caseSituation')"
              :options="caseSituations"
              :custom-label="v => [$t(v.label)].filter(Boolean).join(' ')"
              :multiple="false"
              @remove="saveConfiguration"
              @input="saveConfiguration"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <!-- Scan-widget view -->
    <div v-if="item.type === 'scan-widget'">
      <b-row>
        <b-col>
          <b-form-group>
            <div class="form-label">
              <label>{{ $t('dashboard.widget.identifierType') }}</label>
            </div>
            <vt-combo-select
              v-model="selected"
              track-by="value"
              :options="options"
              label="text"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <div class="form-label">
              <label>{{ $t('global.center') }}</label>
            </div>
            <vt-combo-select
              v-model="selected"
              disabled="true"
              track-by="value"
              :options="options"
              label="text"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="text-right button-section">
      <b-button
        class="btn--primary"
        size="sm"
        @click="$emit('addFilter', item)"
      >
        <i
          class="fal fa-check mr-2"
          aria-hidden="true"
        />{{ $t('global.apply') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import sessionStore from '@/session/sessionStore'
import commonCaseTypeServices from '@/api/resources/common/commonCaseTypeServices'
import { DASHBOARD_SITUATION_CASE_OPTIONS } from '@/api/resources/dashboard/dashboardService'
import { StoreUtils } from '@/shared/util/store-utils'

export default {
    name: 'WidgetConfigurationSidepanel',
    props: {
        item: { type: Object, default: () => { return {} } }
    },
    data() {
        return {
            laboratoriesSelected: [],
            prioritiesSelected: [],
            caseTypesSelected: [],
            caseSituationsSelected: [],
            caseTypes: []
        }
    },
    computed: {
        caseSituations() {
            return Object.keys(DASHBOARD_SITUATION_CASE_OPTIONS).map(key => DASHBOARD_SITUATION_CASE_OPTIONS[key])
        },
        priorities() {
            return sessionStore.state.priorities
        },
        laboratories() {
            return StoreUtils.laboratories
        }
    },
    watch: {
        async item() {
            const savedConfiguration = await customConfigResource.get(this.item.uicomponent)
            if (savedConfiguration && savedConfiguration.config) {
                this.laboratoriesSelected = savedConfiguration.config.laboratoriesSelected
                this.prioritiesSelected = savedConfiguration.config.prioritiesSelected
                this.caseTypesSelected = savedConfiguration.config.caseTypesSelected
                this.caseSituationsSelected = savedConfiguration.config.caseSituationsSelected
            } else {
                this.clearFilters()
            }
        }
    },
    mounted() {
        this.getCaseTypes()
    },
    methods: {
        clearFilters() {
            this.laboratoriesSelected = []
            this.prioritiesSelected = []
            this.caseTypesSelected = []
            this.caseSituationsSelected = null
        },
        closeWidgetConfigurationSidepanel() {
            this.$emit('closeWidgetConfigurationSidepanel', false)
        },
        async getCaseTypes() {
            const [err, response] = await this.toCall(commonCaseTypeServices.getCaseTypes())
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.caseTypes = response
        },
        saveConfiguration() {
            const config = {
                laboratoriesSelected: this.laboratoriesSelected,
                prioritiesSelected: this.prioritiesSelected,
                caseTypesSelected: this.caseTypesSelected,
                caseSituationsSelected: this.caseSituationsSelected
            }
            customConfigResource.save(this.item.uicomponent, config)
        }
    }
}
</script>

<style lang="scss" scoped>
    .widget-configuration-sidepanel .button-section {
        background: vt-color(white-light);
        padding: 10px 0;
        position: sticky;
        bottom: 0;
    }
    .widget-configuration-sidepanel .color-row .btn {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px !important;
        border: none;
    }
    .widget-configuration-sidepanel .color-row .btn.selected,
    .widget-configuration-sidepanel .color-row .btn:hover, {
        box-shadow: 0 0 3px 3px #9c9c9c;
    }
    .widget-configuration-sidepanel .title {
        font-size: font-size(big);
        color: vt-color(primary);
    }
    .widget-configuration-sidepanel .subtitle {
        color: vt-color(dark-text) !important;
        font-weight: bold;
    }
    .widget-configuration-sidepanel .tech-row {
        border-bottom: 1px solid rgb(209, 209, 209);
        font-size: font-size(small);
    }

    .widget-configuration-sidepanel .scroll-area{
        height: calc(100vh - 205px);
        overflow-y: auto;
        overflow-x: hidden;
    }

    @media (max-width: 1300px) {
        .widget-configuration-sidepanel .title {
            font-size: font-size(normal);
            color: vt-color(primary);
        }

        .widget-configuration-sidepanel .scroll-area{
            height: calc(100vh - 180px);
            overflow-y: auto;
            overflow-x: hidden;
        }
    }
</style>

<style lang="scss">
    .widget-configuration-sidepanel .multiselection .multiselect__tags {
        line-height: 1.3 !important;
        height: auto !important;
        display: flex;
        flex-direction: column;
    }
</style>
